interface FocusEnvironment {
  innerWidth: number;
  matchMedia?: (query: string) => { matches: boolean };
}

/** Automatic composer focus must not open a touch device's software keyboard. */
export const canAutoFocusComposer = (
  environment: FocusEnvironment | undefined = typeof window === 'undefined' ? undefined : window
) => Boolean(environment && environment.innerWidth >= 768
  && !environment.matchMedia?.('(pointer: coarse)').matches);

export const restoreFocusWithoutMobileComposer = (
  element: HTMLElement | null,
  environment: FocusEnvironment | undefined = typeof window === 'undefined' ? undefined : window
) => {
  if (!element?.isConnected || (element.id === 'chat-input' && !canAutoFocusComposer(environment))) return false;
  element.focus({ preventScroll: true });
  return true;
};
